// test2580
(2580 && 0);
